import React from 'react'

type Props = {
    percent?: number
    message?: string
    top?: number
    right?: number
    inline?: boolean
    onCancel?: () => void
}

export default function UploadProgress({
    percent,
    message,
    top = 8,
    right = 10,
    inline = false,
    onCancel,
}: Props) {
    const pct = Math.max(0, Math.min(100, Math.round(percent ?? 0)))
    return (
        <div
            style={{
                position: inline ? 'static' : 'absolute',
                top,
                right,
                zIndex: 20,
                background: 'rgba(126, 63, 242, 0.95)', // purple
                color: '#fff',
                padding: '6px 12px',
                borderRadius: 5,
                boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
                display: 'flex',
                alignItems: 'center',
                gap: 8,
                fontSize: 12,
                fontWeight: 600,
            }}
        >
            <span>{message || 'Processing'}</span>
            <span
                style={{
                    background: 'rgba(255,255,255,0.25)',
                    height: 6,
                    width: 70,
                    borderRadius: 999,
                    overflow: 'hidden',
                    display: 'inline-block',
                }}
            >
                <span
                    style={{
                        display: 'block',
                        height: '100%',
                        width: `${pct}%`,
                        background: '#fff',
                        borderRadius: 999,
                        transition: 'width 120ms ease-out',
                    }}
                />
            </span>
            <span>{pct}%</span>
        </div>
    )
}
